export const ONBOARDING_CONSTANTS = {
	HEADER_HEIGHT: 90,
	MERCHANT_DOMAIN: 'liftapp.ai',
	TWITTER_NAME: 'tw-ods9c-odu6e',
	// Index"-1" means that we skip the current onboarding step
	// and navigate user to the next step without choosing any option
	SKIP_STEP_INDEX: -1,
	QUESTION_USER_FOLLOWERS_TEXT: 'How many followers do you have?',
	QUESTION_USER_GOAL_FOR_FOLLOWERS_TEXT:
		'What`s your immediate goal for followers?',
};
export const ONBOARDING_CSS_VARIABLE_NAMES = {};
